import { CharCategory } from "@codemirror/state";

function prevChar(doc, pos) {
    if (pos <= 0) {
        return "";
    }
    return doc.sliceString(pos - 1, pos);
}

function nextChar(doc, pos) {
    if (pos >= doc.length) {
        return "";
    }
    return doc.sliceString(pos, pos + 1);
}

function countSurroundingCharacters(doc, pos, insert) {
    let count = 0;
    let to = pos;
    do {
        const char = doc.sliceString(to - insert.length, to);
        if (char !== insert) {
            break;
        }
        count += 1;
        to -= 1;
    } while (to > 1);

    let from = pos;
    do {
        const char = doc.sliceString(from, from + insert.length);
        if (char !== insert) {
            break;
        }
        count += 1;
        from += 1;
    } while (from < doc.length);

    return count;
}

export const closeBracketConfig = {
    brackets: ["$", "$$", "[", "{", "("],
    buildInsert(state, range, open, close) {
        switch (open) {
            case "$": {
                const prev = prevChar(state.doc, range.head);
                if (prev === "\\") {
                    const preprev = prevChar(state.doc, range.head - prev.length);
                    if (preprev === "\\") {
                        return `${open}$`;
                    }
                    return open;
                }

                const next = nextChar(state.doc, range.head);
                if (next === "\\") {
                    const pos = range.head + prev.length;
                    const postnext = nextChar(state.doc, pos);
                    if (state.charCategorizer(pos)(postnext) !== CharCategory.Word) {
                        return `${open}$`;
                    }
                    return open;
                }

                const count = countSurroundingCharacters(state.doc, range.from, open);
                return count % 2 !== 0 ? open : open + close;
            }

            case "[": {
                const prev = prevChar(state.doc, range.head);
                if (prev === "\\") {
                    const preprev = prevChar(state.doc, range.head - prev.length);
                    if (preprev === "\\") {
                        return `${open}]`;
                    }
                    return `${open}\\${close}`;
                }
                return open + close;
            }

            case "(": {
                const prev = prevChar(state.doc, range.head);
                if (prev === "\\") {
                    const preprev = prevChar(state.doc, range.head - prev.length);
                    if (preprev === "\\") {
                        return open;
                    }
                    return `${open}\\${close}`;
                }
                return open;
            }

            case "{": {
                const prev = prevChar(state.doc, range.head);
                if (prev === "\\") {
                    const preprev = prevChar(state.doc, range.head - prev.length);
                    if (preprev === "\\") {
                        return `${open}}`;
                    }
                    return open;
                }
                return open + close;
            }

            default:
                return open + close;
        }
    },
};
